import { Component, Input } from "@angular/core";

@Component({
  selector: "app-loading-spinner-modal",
  templateUrl: "./loading-spinner-modal.component.html",
  styleUrls: ["./loading-spinner-modal.component.css"],
})
export class LoadingSpinnerModalComponent {
  @Input() accion: string = "";
  @Input() valUno: string = "";
  @Input() valDos: string = "";
}
